import { ListCart } from "@/components/lists/list-cart";
import { ListHeader } from "@/components/lists/list-header";
import { ListSummary } from "@/components/lists/list-summary";
import { Product } from "@/types";
import { usePage } from "@inertiajs/react";

type ListsPageProps = {
  listProducts: Product[];
}

export default function ListsPage({ listProducts }: ListsPageProps) {
  const props = usePage().props
  const listPrice = props.lists_price as number;
  return (
    <main className="min-h-screen">
      <ListHeader />
      <ListCart listProducts={listProducts} />
      <ListSummary listProducts={listProducts} listPrice={listPrice} />
    </main>
  );
}
